import { PrimaryButton } from "../../components";
import { SearchPhrasesIcon } from "../../screenshots";
import React from 'react';
import SectionCard from "./SectioncCard";

const SearchMonitoringSection = () => <div className="max-w-[1200px] lg:mx-auto mb-20">

    <h1 className="text-[#FBFBFC] text-4xl md:text-[60px] font-medium leading-tight mb-12 text-center">
        <span className="text-[#52575D]">Мониторинг фраз  —</span><br className="hidden lg:block" /> ежедневный контроль<br className="hidden lg:block" /> ваших позиций
    </h1>
    <div className="hidden lg:flex space-x-5 self-center">
        <div className="hidden mt-5 lg:flex space-x-5 self-center w-full">
            <div className="flex flex-col space-y-5 w-full">
                <div className="flex justify-between items-center p-20 rounded-[20px] lg:rounded-[60px] bg-[#1B2126] ">
                    <div className="flex flex-col ">
                        <span className="block text-5xl leading-[54px] text-white  font-medium">
                            Проверяем<br className="hidden lg:block" /> поисковые запросы
                        </span>
                        <span className="block mt-10 text-lg text-[#919BA0] font-normal">
                            Покажем позиции товаров на WB и OZ
                        </span>
                        <PrimaryButton className={'w-full mt-10 py-5 lg:w-fit lg:px-12 lg:py-6 flex items-center justify-center'} onClick={() => window.location.href = 'https://go.priceninja.ru/products'}>
                            <span className="text-white font-semibold text-[18px] leading-[21px] lg:text-xl lg:leading-6">
                                Попробовать бесплатно
                            </span>
                        </PrimaryButton>
                    </div>
                    <div className="relative left-20">
                        <SearchPhrasesIcon />
                    </div>
                </div>

            </div>
        </div>
    </div>
    <div className="block lg:hidden space-x-5 self-center">
        <SectionCard size="xs" className="overflow-hidden">
            <div className="relative w-full flex justify-end -right-[40px] mb-10">
                <SearchPhrasesIcon width={270} height={100} />
            </div>
            <span className="block text-3xl leading-[40px] text-white  font-medium">
                Проверяем<br className="hidden lg:block" /> поисковые<br className="hidden lg:block" />  запросы
            </span>
            <span className="block mt-10 text-lg text-[#919BA0] font-normal">
                Покажем позиции товаров на WB и OZ
            </span>
            <PrimaryButton className={'w-full mt-10 py-5 lg:w-fit lg:px-12 lg:py-6 flex items-center justify-center'} onClick={() => window.location.href = 'https://go.priceninja.ru/products'}>
                <span className="text-white font-semibold text-[18px] leading-[21px] lg:text-xl lg:leading-6">
                    Попробовать бесплатно
                </span>
            </PrimaryButton>
        </SectionCard>

    </div>
</div>;


export default SearchMonitoringSection;